"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PhoneMissedCall = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_PhoneMissedCall_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1a.5.5 0 0 0 0 1h1.793L8 5.293 4.354 1.646a.5.5 0 1 0-.708.708l4 4a.5.5 0 0 0 .708 0L12 2.707V4.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05 11.45v.798c0 .554-.22 1.085-.611 1.477l-.865.865a1.393 1.393 0 0 1-1.97 0l-.985-.985c-.797-.798-.838-2.106-.045-2.909l.045-.045a10.439 10.439 0 0 1 14.77 0c.41.409.611.945.611 1.477 0 .532-.202 1.069-.61 1.477l-.985.985a1.392 1.392 0 0 1-1.97 0l-.865-.865a2.089 2.089 0 0 1-.612-1.477v-.797a.69.69 0 0 0-.453-.657 7.676 7.676 0 0 0-5.001 0 .643.643 0 0 0-.248.155.71.71 0 0 0-.206.502Zm-3.723 1.448c-.432-.431-.425-1.108-.043-1.497l.042-.043a9.439 9.439 0 0 1 13.357 0c.211.212.317.49.317.77s-.106.558-.318.77l-.984.985a.392.392 0 0 1-.555 0l-.866-.865a1.089 1.089 0 0 1-.319-.77v-.797a1.69 1.69 0 0 0-1.127-1.602 8.676 8.676 0 0 0-5.65 0c-.247.083-.461.222-.633.393a1.712 1.712 0 0 0-.498 1.209v.798c0 .288-.114.564-.319.769l-.865.865a.392.392 0 0 1-.554 0l-.985-.985Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PhoneMissedCall_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = PhoneMissedCall;
exports["default"] = _default;